import React from "react";
import { Container, Row, Col, Card } from "reactstrap";

function ProductListingReview(props) {

  // Temporary mock data (later this will come from parent state)

  const reviewData = {
    store: "Amazon India",
    productName: "Nike Running Shoes",
    brand: "Nike",
    category: "Sports > Running > Shoes",
    price: "₹1999",
    quantity: 50,
    images: 3
  };

  return (

    <Container>

      <Row>

        {/* Page Title */}

        <Col md={12} className="mt-4 mb-3">
          <h4>Step 9 : Review Listing</h4>
        </Col>


        {/* Review Card */}

        <Col md={12}>

          <Card className="p-4">

            <Row className="mb-3">
              <Col md={12}>
                <h5><b>Review Product Details</b></h5>
              </Col>
            </Row>


            <Row className="mb-2">
              <Col md={4} className="amazon-listing-labels">Store : </Col>
              <Col md={8}>{reviewData.store}</Col>
            </Row>

            <Row className="mb-2">
              <Col md={4} className="amazon-listing-labels">Product Name : </Col>
              <Col md={8}>{reviewData.productName}</Col>
            </Row>

            <Row className="mb-2">
              <Col md={4} className="amazon-listing-labels">Brand : </Col>
              <Col md={8}>{reviewData.brand}</Col>
            </Row>

            <Row className="mb-2">
              <Col md={4} className="amazon-listing-labels">Category : </Col>
              <Col md={8}>{reviewData.category}</Col>
            </Row>

            <Row className="mb-2">
              <Col md={4} className="amazon-listing-labels">Price : </Col>
              <Col md={8}>{reviewData.price}</Col>
            </Row>

            <Row className="mb-2">
              <Col md={4} className="amazon-listing-labels">Inventory : </Col>
              <Col md={8}>{reviewData.quantity} Units</Col>
            </Row>

            <Row className="mb-2">
              <Col md={4} className="amazon-listing-labels">Images Uploaded : </Col>
              <Col md={8}>{reviewData.images}</Col>
            </Row>

          </Card>

        </Col>


        {/* Navigation Buttons */}

        <Col md={12} className="mt-3 d-flex justify-content-between">

          <button
            className="btn btn-light"
            onClick={props.prevStep}
          >
            ← Back
          </button>

          <div>

            <button className="btn btn-secondary mr-2">
              Save Draft
            </button>

            <button
              className="btn btn-success"
              onClick={props.nextStep}
            >
              Publish to Amazon
            </button>

          </div>

        </Col>

      </Row>

    </Container>

  );
}

export default ProductListingReview;